import { Dialog, ControlList, useTranslations, useNumberFormat } from "@harea/component";
import { useState } from "react";
import { useCreateDebauchageFormStep1, useCreateDebauchageFormStep2 } from "../hooks/useCreateDebauchageForm";
import { useCreateDebauchageMutation } from "../hooks/useCreateDebauchageMutation";
import moment from "moment";

const CreateDebauchageContainer = ({ open, onClose }: Props) => {
  const [TITLE, STEP_1, STEP_2, STEP_3, SAVE_DRAFT, VALIDATE, BACK, NEXT, SUMMARY, PERSONNEL, DEPARTURE_TYPE, EFFECTIVE_DATE, REASON, RESIGNATION_LETTER, DISMISSAL_PV, SOLDE_DE_TOUT_COMPTE, INDEMNITIES, TOTAL, STEP_2_DOCUMENTS, DOCUMENTS, INDEMNITIES_AUTO_NOTE, STEP, RESIGNATION, MISCONDUCT, SERIOUS_MISCONDUCT, CONTRACT_END, NEGOTIATED_RESIGNATION] = useTranslations(i18n);
  const formStep1 = useCreateDebauchageFormStep1();
  const formStep2 = useCreateDebauchageFormStep2();
  const createMutation = useCreateDebauchageMutation();
  const formatCurrency = useNumberFormat({
    style: "currency",
    currency: "MGA",
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState<any>({});

  const handleStep1Submit = (value: any) => {
    setFormData({ ...formData, ...value });
    setCurrentStep(2);
  };

  const handleStep2Submit = (value: any) => {
    setFormData({ ...formData, ...value });
    setCurrentStep(3);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = () => {
    const payload: any = {
      personnelId: formData.personnel?.id,
      departureType: formData.departureType,
      effectiveDate: formData.effectiveDate,
    };

    if (formData.reason) payload.reason = formData.reason;
    if (formData.resignationLetter?.id) payload.resignationLetterId = formData.resignationLetter.id;
    if (formData.dismissalPV?.id) payload.dismissalPVId = formData.dismissalPV.id;
    if (formData.soldeDeToutCompte?.id) payload.soldeDeToutCompteId = formData.soldeDeToutCompte.id;

    createMutation.mutate(payload, {
      onSuccess: () => {
        onClose();
        setCurrentStep(1);
        setFormData({});
      },
      onError: (error: any) => {
        console.error("Erreur création débauchage:", error);
      },
    });
  };

  const getDepartureTypeLabel = (type?: string) => {
    const labels: Record<string, string> = {
      RESIGNATION: RESIGNATION,
      MISCONDUCT: MISCONDUCT,
      SERIOUS_MISCONDUCT: SERIOUS_MISCONDUCT,
      CONTRACT_END: CONTRACT_END,
      NEGOTIATED_RESIGNATION: NEGOTIATED_RESIGNATION,
    };
    return labels[type || ""] || type || "-";
  };

  const renderStep = () => {
    console.log("Current step:", currentStep);
    console.log("Form step 2:", formStep2);
    switch (currentStep) {
      case 1:
        return (
          <ControlList
            {...formStep1}
            onSubmited={handleStep1Submit}
            onCancel={onClose}
          />
        );
      case 2:
        return (
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              {STEP_2_DOCUMENTS}
            </p>
            <ControlList
              {...formStep2}
              onSubmited={handleStep2Submit}
              onCancel={handleBack}
            />
          </div>
        );
      case 3:
        return (
          <div className="space-y-4">
            <div className="border rounded-lg p-4 space-y-3">
              <h3 className="font-semibold text-lg">{SUMMARY || "Récapitulatif"}</h3>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <span className="text-sm text-muted-foreground">{PERSONNEL || "Employé"}:</span>
                  <p className="font-medium">{formData.personnel?.fullName || "-"}</p>
                </div>
                <div>
                  <span className="text-sm text-muted-foreground">{DEPARTURE_TYPE || "Type de départ"}:</span>
                  <p className="font-medium">{getDepartureTypeLabel(formData.departureType)}</p>
                </div>
                <div>
                  <span className="text-sm text-muted-foreground">{EFFECTIVE_DATE || "Date effective"}:</span>
                  <p className="font-medium">
                    {formData.effectiveDate ? moment(formData.effectiveDate).format("DD/MM/YYYY") : "-"}
                  </p>
                </div>
                <div>
                  <span className="text-sm text-muted-foreground">{REASON || "Raison"}:</span>
                  <p className="font-medium">{formData.reason || "-"}</p>
                </div>
              </div>

              <div className="border-t pt-3 mt-3">
                <h4 className="font-medium mb-2">{DOCUMENTS}</h4>
                <div className="space-y-2">
                  <div>
                    <span className="text-sm text-muted-foreground">{RESIGNATION_LETTER || "Lettre de démission"}:</span>
                    <p className="font-medium">{formData.resignationLetter?.name || "-"}</p>
                  </div>
                  <div>
                    <span className="text-sm text-muted-foreground">{DISMISSAL_PV || "PV de licenciement"}:</span>
                    <p className="font-medium">{formData.dismissalPV?.name || "-"}</p>
                  </div>
                  <div>
                    <span className="text-sm text-muted-foreground">{SOLDE_DE_TOUT_COMPTE || "Solde de tout compte"}:</span>
                    <p className="font-medium">{formData.soldeDeToutCompte?.name || "-"}</p>
                  </div>
                </div>
              </div>

              <div className="border-t pt-3 mt-3 bg-yellow-50 p-4 rounded-lg">
                <h4 className="font-medium mb-2">{INDEMNITIES || "Indemnités calculées"}</h4>
                <p className="text-sm text-muted-foreground mb-2">
                  {INDEMNITIES_AUTO_NOTE}
                </p>
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                className="px-4 py-2 border rounded-md hover:bg-gray-100"
                onClick={handleBack}
              >
                {BACK || "Retour"}
              </button>
              <button
                className="px-4 py-2 border rounded-md hover:bg-gray-100"
                onClick={() => {
                  const payload: any = {
                    personnelId: formData.personnel?.id,
                    departureType: formData.departureType,
                    effectiveDate: formData.effectiveDate,
                  };
                  if (formData.reason) payload.reason = formData.reason;
                  if (formData.resignationLetter?.id) payload.resignationLetterId = formData.resignationLetter.id;
                  if (formData.dismissalPV?.id) payload.dismissalPVId = formData.dismissalPV.id;
                  if (formData.soldeDeToutCompte?.id) payload.soldeDeToutCompteId = formData.soldeDeToutCompte.id;
                  createMutation.mutate(payload, {
                    onSuccess: () => {
                      onClose();
                      setCurrentStep(1);
                      setFormData({});
                    },
                  });
                }}
              >
                {SAVE_DRAFT || "Enregistrer brouillon"}
              </button>
              <button
                className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90"
                onClick={handleSubmit}
              >
                {VALIDATE || "Valider"}
              </button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      title={`${TITLE || "Créer un débauchage"} - ${STEP} ${currentStep}/3`}
      onClose={onClose}
      onCancel={currentStep === 1 ? onClose : handleBack}
    >
      {renderStep()}
    </Dialog>
  );
};

type Props = {
  open: boolean;
  onClose: () => void;
};

export default CreateDebauchageContainer;

const i18n = [
  "std_create_debauchage",
  "std_step_1",
  "std_step_2",
  "std_step_3",
  "std_save_draft",
  "std_validate",
  "std_back",
  "std_next",
  "std_summary",
  "std_personnel",
  "std_departure_type",
  "std_effective_date",
  "std_reason",
  "std_resignation_letter",
  "std_dismissal_pv",
  "std_solde_de_tout_compte",
  "std_indemnities",
  "std_total",
  "std_step_2_documents",
  "std_documents",
  "std_indemnities_auto_note",
  "std_step",
  "std_resignation",
  "std_misconduct",
  "std_serious_misconduct",
  "std_contract_end",
  "std_negotiated_resignation",
];
